// passed to getTvProps
export type TVConfig = {
    channels?: (number | string)[]
    columnSpan?: number
    align?: 'right' | 'left' | 'center'
    aspectRatio?: number
}

// passed to the TV component
export type TVProps = {
    height: number
    width: number
    top: number
    left: number
    columnOffset: number
    margin: number
    offset: number
    indexes: number[]
} & TVConfig

// mostly a cut and paste refactor of what's in @giphy/react-giphy-tv
export const getTvProps = (
    { channels = ['@trending'], columnSpan = 2, aspectRatio = 16 / 9, align = 'left' }: TVConfig,
    columnWidth: number,
    gutterSize: number,
    columns: number
): TVProps => {
    const width = Math.round(columnSpan * columnWidth + (columnSpan - 1) * gutterSize)
    let columnOffset = 0
    // column alignment
    if (align === 'center') {
        columnOffset = Math.round((columns - columnSpan) / 2)
    } else if (align === 'right') {
        columnOffset = columns - columnSpan
    }
    const indexes: number[] = []
    // just check the first 20 gifs, TVs are at the top
    for (let index = 0; index < 20; index++) {
        if (index >= columnOffset && index < columnSpan + columnOffset) indexes.push(index)
    }
    const height = Math.round(width / aspectRatio)
    const left = columnOffset ? Math.round(columnOffset * (columnWidth + gutterSize)) : 0
    return {
        channels,
        width,
        height,
        top: 0,
        left,
        columnOffset,
        columnSpan,
        margin: gutterSize,
        offset: height + gutterSize,
        indexes,
    }
}

export const getGifWidthForTV = (width: number, gutter: number, columns: number) => {
    const gutterOffset = gutter * (columns - 1)
    return Math.floor((width - gutterOffset) / columns)
}
